export const APPROVALS_ENDPOINTS = {
  roles: 'enrollment-approval/listapprovalrole',
  listUsers: 'enrollment-approval/listapprovalusers',
  singleUserDetails: 'enrollment-approval/getuserdetails',
  approve_reject: 'enrollment-approval/action',
  verification_action: 'enrollment-approval/verification-action',
} as const;



export const Blocklist_ENDPOINTS = {
  blocklist: 'bill-upload-config/list-blacklist',
  campaignBlocklist: 'bill-upload-config/list-campaigns',
  addBlacklist: 'bill-upload-config/add-blacklist',
  toggleBlacklistStatus: 'bill-upload-config/toggle-blacklist-status',
  unblock: 'bill-upload-config/unblock',
} as const;
